module.exports = __webpack_public_path__ + "img/bank.41843ebb.png";